import React from "react";
import "./Template.css";
import "../transitionBanner/transitionBanner.css";
import "../logo/logo.css";
import TransitionBanner from "../transitionBanner/transitionBanner";
import NavigationBar from "../navigationBar/navigationBar";
import Logo from "../logo/logo";
import Footer from "../footer/footer";
import { Helmet } from "react-helmet-async";
import { useRef } from "react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function Template({ children }) {
  const topPage = useRef(null);

  const location = useLocation();
  useEffect(() => {
    if (location.hash === "#top-page" && topPage.current) {
      topPage.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [location]);
  return (
    <div>
      <style>
        @import
        url('https://fonts.googleapis.com/css2?family=Rubik+Mono+One&display=swap');
        @import
        url('https://fonts.googleapis.com/css2?family=Orbitron:wght@400..900&display=swap');
        @import
        url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Roboto:ital,wght@0,100..900;1,100..900&display=swap');
      </style>
      <Helmet>
        <title>Controle Réparation</title>
        <meta
          name="description"
          content="Dépannage et réparation informatique à domicile, à Toulouse, 7j/7,  pour particuliers et entreprises. Services de dépannage, optimisation et maintenance adaptés à vos besoins."
        />
      </Helmet>

      {/* Logo and nav */}
      <div className="top-bar" ref={topPage}>
        {/* Logo */}
        <Logo />

        {/* Barre de navigation */}
        <NavigationBar />
      </div>

      {/* Contenu de la page */}
      <main className="template-main">
        {/* Barre de séparation */}
        <TransitionBanner />

        <div className="page-content">
          {children}
          <Footer />
        </div>
      </main>
    </div>
  );
}

export default Template;
